import { FormsApi } from './forms.api'
export { FormsApi } from './forms.api'

export default {
  forms: FormsApi
}
